export const customerFileUploadMaxSizeBytes = 10000000; // 10MB
export const customerFileUploadMaxSizeBase64Bytes = 2000000; // 2MB
